import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

const getStoredLanguage = () => {
  const stored = localStorage.getItem('i18nextLng');
  return stored || 'en';
};

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: getStoredLanguage(),
    fallbackLng: 'de',
    ns: ['common'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: `${process.env.REACT_APP_API_URL || 'http://localhost:6017'}/locales/{{lng}}/{{ns}}.json`,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n; 